
import { PosLeaderboard } from "@/domain/entities/PosLeaderboard";
import { defineComponent, toRefs, computed } from "vue";
import formatPriceRP from '@/app/infrastructures/misc/common-library/v2/FormatPriceRP';
import { AccountController } from '@/app/ui/controllers/AccountController';

export default defineComponent({
  name: "CardLiolio",
  props: {
    isCustomFilter: {
      type: Boolean,
      default: false
    },
    month: {
      type: String,
      default: ""
    },
    data: {
      type: PosLeaderboard,
      default: new PosLeaderboard()
    }
  },
  setup(props) {
    const accountCurrency = computed(() => {
      return (
        (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ??
        "IDR"
      );
    });

    return { ...toRefs(props), formatPriceRP: formatPriceRP, accountCurrency };
  }
});
